import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  isDark: boolean;
  toggleTheme: () => void;
  reset: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDark: false,
      toggleTheme: () => set((state) => ({ isDark: !state.isDark })),
      reset: () => {
        set({ isDark: false });
        localStorage.removeItem('theme-storage');
      },
    }),
    {
      name: 'theme-storage',
    }
  )
);